import { CoreIcon } from '../core-icon';
import questionCircleSVG from '../../assets/icons/question-circle.svg';
import type { IconProps } from '../core-icon';

export const QuestionCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={questionCircleSVG} {...props} />;
};
